import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

const UFs = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

export default function AdminVeiculoForm() {
  const { id } = useParams();
  const nav    = useNavigate();
  const isEdit = !!id;
  const inputFotosRef = useRef();

  const [form, setForm] = useState({
    marca:'', modelo:'', versao:'', ano:'', preco:'', quilometragem:'',
    cambio:'', combustivel:'', cor:'', motor:'',
    cidade:'', estado:'', descricao:'',
    nome_vendedor:'', whatsapp_vendedor:'', email_vendedor:'',
    cidade_vendedor:'', estado_vendedor:'',
    status:'disponivel', publicado:false, destaque:false,
    original:false, placa_preta:false, restaurado:false,
    quitado:true, documentacao_em_dia:true,
  });

  const [fotosExistentes, setFotosExistentes] = useState([]);
  const [novasFotos, setNovasFotos]           = useState([]);
  const [salvando, setSalvando]               = useState(false);
  const [enviandoFotos, setEnviandoFotos]     = useState(false);
  const [removendo, setRemovendo]             = useState(null);
  const [msg, setMsg]                         = useState('');
  const [msgFotos, setMsgFotos]               = useState('');

  const carregarVeiculo = () => {
    api.get(`/admin/veiculos/${id}`).then(({ data }) => {
      setForm(f => ({ ...f, ...data }));
      setFotosExistentes(data.fotos || []);
    }).catch(() => {});
  };

  useEffect(() => {
    if (isEdit) carregarVeiculo();
  }, [id]);

  const upd = e => {
    const v = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(f => ({ ...f, [e.target.name]: v }));
  };

  const salvar = async e => {
    e.preventDefault(); setSalvando(true); setMsg('');
    try {
      if (isEdit) {
        await api.patch(`/admin/veiculos/${id}`, form);
      } else {
        const fd = new FormData();
        Object.entries(form).forEach(([k,v]) => fd.append(k, v));
        Array.from(novasFotos).forEach(f => fd.append('fotos', f));
        await api.post('/admin/veiculos', fd, { headers: { 'Content-Type':'multipart/form-data' } });
      }
      nav('/admin/veiculos');
    } catch { setMsg('Erro ao salvar. Verifique os campos.'); }
    finally { setSalvando(false); }
  };

  const enviarNovasFotos = async () => {
    if (!novasFotos.length) return;
    setEnviandoFotos(true); setMsgFotos('');
    try {
      const fd = new FormData();
      Array.from(novasFotos).forEach(f => fd.append('fotos', f));
      const { data } = await api.post(`/admin/veiculos/${id}/fotos`, fd, {
        headers: { 'Content-Type':'multipart/form-data' },
      });
      setFotosExistentes(data.fotos);
      setNovasFotos([]);
      if (inputFotosRef.current) inputFotosRef.current.value = '';
      setMsgFotos('Fotos adicionadas com sucesso.');
    } catch { setMsgFotos('Erro ao enviar fotos.'); }
    finally { setEnviandoFotos(false); }
  };

  const excluirFoto = async (fotoId) => {
    if (!window.confirm('Excluir esta foto?')) return;
    setRemovendo(fotoId);
    try {
      await api.delete(`/admin/veiculos/${id}/fotos/${fotoId}`);
      setFotosExistentes(prev => prev.filter(f => f.id !== fotoId));
    } catch { alert('Erro ao excluir foto.'); }
    finally { setRemovendo(null); }
  };

  const definirPrincipal = async (fotoId) => {
    try {
      await api.patch(`/admin/veiculos/${id}/fotos/${fotoId}/principal`);
      setFotosExistentes(prev => prev.map(f => ({ ...f, principal: f.id === fotoId ? 1 : 0 })));
    } catch { alert('Erro ao definir foto principal.'); }
  };

  const Section = ({ title, children }) => (
    <div className="card" style={{ padding:'28px 32px', marginBottom:20 }}>
      <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:19, marginBottom:22, paddingBottom:14, borderBottom:'1px solid var(--border)' }}>{title}</h3>
      {children}
    </div>
  );

  const estiloGrade = { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(160px, 1fr))', gap:12 };
  const estiloCapa  = { position:'relative', borderRadius:8, overflow:'hidden', border:'2px solid var(--border)', background:'#f5f5f5' };
  const estiloImg   = { width:'100%', height:120, objectFit:'cover', display:'block' };
  const estiloBar   = { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 8px', background:'rgba(0,0,0,.04)', gap:4 };

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-title">{isEdit ? 'Editar veiculo' : 'Novo veiculo'}</h1>
          <button onClick={() => nav('/admin/veiculos')} className="btn btn-outline btn-sm">Voltar</button>
        </div>

        {msg && <div className="alert alert-danger" style={{ marginBottom:20 }}>{msg}</div>}

        <form onSubmit={salvar}>
          <Section title="Dados do veiculo">
            <div className="form-row">
              <div className="form-group"><label>Marca *</label><input name="marca" value={form.marca} onChange={upd} required /></div>
              <div className="form-group"><label>Modelo *</label><input name="modelo" value={form.modelo} onChange={upd} required /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Versao</label><input name="versao" value={form.versao} onChange={upd} /></div>
              <div className="form-group"><label>Ano *</label><input name="ano" type="number" value={form.ano} onChange={upd} min="1900" max="2000" required /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Preco (R$)</label><input name="preco" type="number" value={form.preco} onChange={upd} /></div>
              <div className="form-group"><label>Quilometragem</label><input name="quilometragem" type="number" value={form.quilometragem} onChange={upd} /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Cambio</label>
                <select name="cambio" value={form.cambio} onChange={upd}>
                  <option value="">-</option><option value="manual">Manual</option><option value="automatico">Automatico</option>
                </select>
              </div>
              <div className="form-group"><label>Combustivel</label>
                <select name="combustivel" value={form.combustivel} onChange={upd}>
                  <option value="">-</option><option value="gasolina">Gasolina</option><option value="etanol">Etanol</option><option value="flex">Flex</option><option value="diesel">Diesel</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Cor</label><input name="cor" value={form.cor} onChange={upd} /></div>
              <div className="form-group"><label>Motor</label><input name="motor" value={form.motor} onChange={upd} /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Cidade</label><input name="cidade" value={form.cidade} onChange={upd} /></div>
              <div className="form-group"><label>Estado</label>
                <select name="estado" value={form.estado} onChange={upd}>
                  <option value="">-</option>{UFs.map(e=><option key={e}>{e}</option>)}
                </select>
              </div>
            </div>
            <div className="form-group"><label>Descricao</label><textarea name="descricao" value={form.descricao} onChange={upd} rows={4} /></div>

            <div style={{ display:'flex', gap:20, flexWrap:'wrap', paddingTop:8 }}>
              {[['original','Original'],['placa_preta','Placa preta'],['restaurado','Restaurado'],['publicado','Publicado'],['destaque','Destaque'],['quitado','Quitado'],['documentacao_em_dia','Doc. em dia']].map(([n,l]) => (
                <label key={n} className="checkbox-group">
                  <input type="checkbox" name={n} checked={!!form[n]} onChange={upd} />
                  <span style={{ fontSize:14 }}>{l}</span>
                </label>
              ))}
            </div>
          </Section>

          <Section title="Dados do vendedor">
            <div className="form-row">
              <div className="form-group"><label>Nome do vendedor</label><input name="nome_vendedor" value={form.nome_vendedor} onChange={upd} /></div>
              <div className="form-group"><label>WhatsApp</label><input name="whatsapp_vendedor" value={form.whatsapp_vendedor} onChange={upd} /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>E-mail</label><input name="email_vendedor" type="email" value={form.email_vendedor} onChange={upd} /></div>
              <div className="form-group"><label>Cidade</label><input name="cidade_vendedor" value={form.cidade_vendedor} onChange={upd} /></div>
            </div>
            <div className="form-group" style={{ maxWidth:200 }}>
              <label>Estado</label>
              <select name="estado_vendedor" value={form.estado_vendedor} onChange={upd}>
                <option value="">-</option>{UFs.map(e=><option key={e}>{e}</option>)}
              </select>
            </div>
          </Section>

          <div style={{ display:'flex', gap:12, marginBottom:28 }}>
            <button type="submit" className="btn btn-primary" disabled={salvando}>
              {salvando ? 'Salvando...' : isEdit ? 'Salvar alteracoes' : 'Cadastrar veiculo'}
            </button>
            <button type="button" className="btn btn-outline" onClick={() => nav('/admin/veiculos')}>Cancelar</button>
          </div>
        </form>

        {/* Secao de fotos — exibida apenas no modo edicao */}
        {isEdit && (
          <Section title="Fotos do veiculo">
            {fotosExistentes.length === 0 && (
              <p style={{ color:'var(--ink-muted)', fontSize:13, marginBottom:16 }}>
                Nenhuma foto cadastrada ainda.
              </p>
            )}

            {fotosExistentes.length > 0 && (
              <div style={{ marginBottom:24 }}>
                <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:12 }}>
                  Clique em "Principal" para definir a capa do anuncio. A exclusao e imediata.
                </p>
                <div style={estiloGrade}>
                  {fotosExistentes.map(foto => (
                    <div key={foto.id} style={{ ...estiloCapa, borderColor: foto.principal ? 'var(--rust)' : 'var(--border)' }}>
                      {foto.principal && (
                        <div style={{ position:'absolute', top:6, left:6, background:'var(--rust)', color:'#fff', fontSize:10, fontWeight:700, padding:'2px 7px', borderRadius:4, letterSpacing:1 }}>
                          CAPA
                        </div>
                      )}
                      <img src={foto.url} alt="" style={estiloImg} />
                      <div style={estiloBar}>
                        {!foto.principal && (
                          <button
                            type="button"
                            onClick={() => definirPrincipal(foto.id)}
                            style={{ fontSize:11, background:'none', border:'1px solid var(--border)', borderRadius:4, padding:'2px 8px', cursor:'pointer' }}
                          >
                            Principal
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => excluirFoto(foto.id)}
                          disabled={removendo === foto.id}
                          style={{ fontSize:11, background:'none', border:'1px solid #e44', color:'#c33', borderRadius:4, padding:'2px 8px', cursor:'pointer', marginLeft:'auto' }}
                        >
                          {removendo === foto.id ? '...' : 'Excluir'}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ borderTop:'1px solid var(--border)', paddingTop:20 }}>
              <p style={{ fontSize:13, fontWeight:600, marginBottom:10 }}>Adicionar novas fotos</p>
              {msgFotos && (
                <div className={msgFotos.includes('sucesso') ? 'alert alert-success' : 'alert alert-danger'} style={{ marginBottom:12 }}>
                  {msgFotos}
                </div>
              )}
              <div style={{ display:'flex', gap:12, alignItems:'flex-end' }}>
                <div className="form-group" style={{ margin:0, flex:1 }}>
                  <input
                    type="file"
                    multiple
                    accept="image/*"
                    ref={inputFotosRef}
                    onChange={e => setNovasFotos(e.target.files)}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={enviarNovasFotos}
                  disabled={enviandoFotos || !novasFotos.length}
                >
                  {enviandoFotos ? 'Enviando...' : 'Enviar fotos'}
                </button>
              </div>
            </div>
          </Section>
        )}

        {/* Fotos no modo criacao */}
        {!isEdit && (
          <div className="card" style={{ padding:'28px 32px', marginBottom:20 }}>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:19, marginBottom:22, paddingBottom:14, borderBottom:'1px solid var(--border)' }}>Fotos</h3>
            <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:16 }}>A primeira imagem selecionada sera a foto principal.</p>
            <div className="form-group">
              <label>Selecionar fotos</label>
              <input type="file" multiple accept="image/*" onChange={e => setNovasFotos(e.target.files)} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
